import React from 'react';
// Components
import ListOfAssignedStreamsTable from 'components/common/ListOfAssignedStreamsTable/ListOfAssignedStreamsTable';

const ListOfAssignedStreams = (): JSX.Element => {
  return <ListOfAssignedStreamsTable />;
};

export default ListOfAssignedStreams;
